import React, { useState, useEffect } from "react";
import EditDepartmentForm from "./EditDepartmentForm";
import AddDepartmentForm from "./AddDepartmentForm";

const DepartmentSearch = ({ refreshTrigger }) => {
  const [departments, setDepartments] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [showEditDepartmentForm, setShowEditDepartmentForm] = useState(false);
  const [showAddDepartmentForm, setShowAddDepartmentForm] = useState(false);

  const fetchDepartments = () => {
    fetch('/api/departments')
      .then(r => {
        if (!r.ok) throw new Error('Failed to fetch departments');
        return r.json();
      })
      .then(data => {
        console.log('API /api/departments ->', data); // sanity check
        setDepartments(data);
      })
      .catch(e => console.error('Error fetching department:', e));
  };

  useEffect(() => {
    fetchDepartments();
  }, [refreshTrigger]);

  const filteredDepartments = departments.filter(dept =>
    (dept.department_name?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (dept.department_code?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (dept.description?.toLowerCase() || '').includes(searchQuery.toLowerCase())
  );

  const handleAddDepartment = () => setShowAddDepartmentForm(true);
  const handleEditDepartment = (department) => { setSelectedDepartment(department); setShowEditDepartmentForm(true); };
  const handleSaveDepartment = () => { fetchDepartments(); setShowEditDepartmentForm(false); };
  const handleDepartmentAdded = () => { fetchDepartments(); setShowAddDepartmentForm(false); };

  useEffect(() => {
  fetch("/api/departments")
    .then(r => r.json())
    .then(data => { console.log('departments', data); setDepartments(data); });
}, []);


  return (
    <div className="user-list-container">
      <h2>Department List</h2>

      <div>
        <label>Search:</label>
        <input
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="button-container">
        <button className="add-Department-button" onClick={handleAddDepartment}>Add Department</button>
      </div>

      <div className="UserList-container">
        <table>
          <thead>
            <tr>
              <th>Department Code</th>
              <th>Department Name</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredDepartments.length > 0 ? (
              filteredDepartments.map((department) => (
                <tr key={department.department_id}>
                  <td>{department.department_code}</td>
                  <td>{department.department_name}</td>
                  <td>{department.description}</td> {/* <-- correct field */}
                  <td>
                    <button onClick={() => handleEditDepartment(department)}>Edit</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No Department match your search.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showEditDepartmentForm && selectedDepartment && (
        <EditDepartmentForm
          department={selectedDepartment}
          onClose={() => setShowEditDepartmentForm(false)}
          onSave={handleSaveDepartment}
        />
      )}

      {showAddDepartmentForm && (
        <AddDepartmentForm
          onClose={() => setShowAddDepartmentForm(false)}
          onDepartmentAdded={handleDepartmentAdded}
        />
      )}
    </div>
  );
};

export default DepartmentSearch;
